// import { Component, ViewEncapsulation, OnInit, ViewChild  } from '@angular/core';

// import { DxReportViewerComponent } from 'devexpress-reporting-angular';

// @Component({
// selector: 'app-report-viewer',
// encapsulation: ViewEncapsulation.None,
// templateUrl: './report-viewer.component.html',
// styleUrls: [
//     "../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css",
//     "../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css",
//     "../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css"
// ]
// })
// export class ReportViewerComponent  implements OnInit  {

//     @ViewChild(DxReportViewerComponent, { static: false }) viewer: DxReportViewerComponent;
//     reportUrl: string = "Template2";
//     invokeAction: string = '/DXXRDV';
//     hostUrl: string = 'http://192.168.3.33:7774/';
//     title = 'DXReportViewerSample';

// constructor() {
// }

// ngOnInit() {
//     var parameterValue = "<RequestMsg><serviceid>2800</serviceid></RequestMsg>";
//     this.viewer.bindingSender.GetParametersModel()["Parameter1"](parameterValue);
//     this.viewer.bindingSender.StartBuild();
// }




import { Component, Inject, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { DxReportViewerComponent } from 'devexpress-reporting-angular';

import { ActivatedRoute, Router } from '@angular/router';
import { AppConfigService } from 'src/app/app-config.service.service';

import { GeneralService } from 'src/app/services/general.service';

@Component({
    selector: 'app-report-viewer',
    encapsulation: ViewEncapsulation.None,
    templateUrl: './report-viewer.component.html',
    styleUrls: [
        "../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.common.css",
        "../../../../node_modules/@devexpress/analytics-core/dist/css/dx-analytics.light.css",
        "../../../../node_modules/devexpress-reporting/dist/css/dx-webdocumentviewer.css"
    ]
})
export class ReportViewerComponent implements OnInit {
    @ViewChild(DxReportViewerComponent, { static: false }) viewer: DxReportViewerComponent;
    reportUrl: string = "Template1";
    //reportUrl: string = "SWOTemplate1?paramXML=''";
    invokeAction: string = '/DXXRDV';
    hostUrl: string = 'http://192.168.3.33:7774/';
    //hostUrl: string = 'http://localhost:1908/';

    paramReportName: string;
    paramReportParameter: string;
    estimateID: string;

    sub: any;
    showReport = false;

    constructor(private route: ActivatedRoute, private router: Router, private appConfigService: AppConfigService, private generalService: GeneralService) {

      if (!appConfigService.appConfig) {
        appConfigService.loadAppConfig()
      }

      this.hostUrl = this.appConfigService.reportingURL;
      this.invokeAction = 'DXXRDV';

    }

    ngOnInit() {

        // console.log('estoy en el init')

        // if(localStorage.getItem('dataReporte') != undefined){

        //     let data = JSON.parse(localStorage.getItem('dataReporte'))
        //     this.estimateID = data.reportparameters

        //     console.log(this.estimateID)

        // } else {
            this.sub = this.route
            .queryParams
            .subscribe(params => {
    
              // Defaults to 0 if no query param provided.
            var displayName = "";
            if (params['displayName'] != undefined){
                displayName = "&displayName=" + params['displayName'];
            }


            this.reportUrl = params['reportname'] + "?" + "paramXML=<RequestMsg>" + params['reportparameters'] + "</RequestMsg>&userToken=" + localStorage.getItem("token") + displayName;
    
            if (params['reportname']=="9550ProjectPartReference"){
                this.showReport = true;
            }
            console.log('Params ', params['reportparameters']);
            if (params['reportparameters'].includes("estimateid") )
            {
                console.log(params['reportparameters']);
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString(params['reportparameters'], "text/xml");
                console.log(xmlDoc);
                this.estimateID = xmlDoc.getElementsByTagName("estimateid")[0].childNodes[0].nodeValue;
                console.log(this.estimateID);
            }
    
            //   var parameterValue = "<RequestMsg>" + params['reportparameters'] + "</RequestMsg>";
            //   this.reportUrl = params['reportname'];
            //   this.viewer.bindingSender.GetParametersModel()["parameter1"](parameterValue);
            //   this.viewer.bindingSender.StartBuild();
    
            });
        // }

        // if(localStorage.getItem('dataReporte') != undefined) localStorage.removeItem('dataReporte')


    }

    ngAfterViewInit() {

        // this.sub = this.route
        // .queryParams
        // .subscribe(params => {
        //   // Defaults to 0 if no query param provided.
        //   this.printReport(params['reportname'], params['reportparameters']);

        //   this.paramReportName = params['reportname'];
        //   this.paramReportParameter = params['reportparameters'];

        // //   var parameterValue = "<RequestMsg>" + params['reportparameters'] + "</RequestMsg>";
        // //   this.reportUrl = params['reportname'];
        // //   this.viewer.bindingSender.GetParametersModel()["parameter1"](parameterValue);
        // //   this.viewer.bindingSender.StartBuild();

        // });

    }

    parametersSubmitted2(event) {

        // var mythis = this;
        // console.log('AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA');
        // console.log(event.args.Parameters);
        // if (event.args.Parameters.length > 0){
        //     event.args.Parameters.filter(function (p)
        //     {
        //         console.log('Daleeeeeeeee');
        //         console.log(p);
        //         return p.Key == "paramXML";
        //     })
        //     [0].Value = "<RequestMsg>" + mythis.paramReportParameter + "</RequestMsg>";
        // }

    }

    printReport(reportname, parameterXML) {

        setTimeout (() => {
            // var parameterValue = "<RequestMsg>" + parameterXML + "</RequestMsg>";
            this.reportUrl = reportname;
            // this.viewer.bindingSender.GetParametersModel()["parameter1"](parameterValue);
            this.viewer.bindingSender.StartBuild();
        }, 500);

    }

    OnCustomizeElements(event) {
        var rightPanel = event.args.GetById(this.viewer.bindingSender.RightPanel);
        var index = event.args.Elements.indexOf(rightPanel);
        event.args.Elements.splice(index, 1);
    }

    exportDocument() {
        this.generalService.DownloadDocumentByEstimateId(this.estimateID);
    }    

}



//title = 'DXReportViewerSample';
// The report's path. The Document Viewer opens it when the application starts.
//reportUrl: string = 'Template1';
// Backend's project URI.

//hostUrl: string = 'http://192.168.3.33:7774/';
// hostUrl: string = 'https://localhost:54114/';
// Use this line if you use an ASP.NET MVC backend
// invokeAction: string = "/WebDocumentViewer/Invoke";
// Uncomment this line if you use an ASP.NET Core backend
//invokeAction: string = '/DXXRDV';
// }
